export interface VlogPost {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  duration: string;
  /** ISO date string e.g. '2025-09-15' — used for schema */
  publishedAt: string;
  /** Human-readable date e.g. 'Sep 15, 2025' — used for display */
  publishDate: string;
  views: number;
  episode: number;
  /** Must match one of the vlogCategories slugs */
  category: string;
  tags: string[];
  featured?: boolean;
  youtubeId?: string;
  tiktokClipUrl?: string;
}

/**
 * Slugs must stay in sync with the categories array in vlog/page.tsx.
 */
export const vlogCategories = [
  'all',
  'rockhound-life',
  'dealer-tactics',
  'buying-tips',
  'industry-watch',
];

export const vlogPosts: VlogPost[] = [
  {
    id: 'vlog-001',
    title: 'Why We Started Rockhound Auto — The Full Story',
    description:
      'Two bald guys, two bad dealership experiences too many. We walk you through every turning point that made us say enough is enough and build something honest. The origin story nobody asked for, but we\'re telling it anyway.',
    thumbnail:
      'https://public.readdy.ai/ai/img_res/db7b6d35415eb2e19cdd845f76887e67.jpg',
    duration: '18:22',
    publishedAt: '2025-09-15',
    publishDate: 'Sep 15, 2025',
    views: 8421,
    episode: 1,
    category: 'rockhound-life',
    tags: ['origin story', 'founding', 'honest dealership'],
    featured: true,
    youtubeId: 'ScMzIvxBSi4',
  },
  {
    id: 'vlog-002',
    title: 'The Finance Office Playbook: What Dealers Do In That Back Room',
    description:
      'We worked the finance office. We know every upsell script, every stall tactic, every sleight-of-hand move. Here\'s the full playbook — so next time you\'re sitting across that desk, nothing surprises you.',
    thumbnail:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20car%20dealership%20finance%20office%20desk%20with%20contract%20paperwork%20pen%20signing%20stack%20of%20documents%20dramatic%20overhead%20lighting%20tense%20atmosphere%20dark%20wood%20desk%20warm%20incandescent%20light%20selective%20focus%20shallow%20depth%20of%20field%20editorial%20documentary%20photography&width=800&height=450&seq=vlog-ep2-thumb&orientation=landscape',
    duration: '22:07',
    publishedAt: '2025-10-03',
    publishDate: 'Oct 3, 2025',
    views: 12340,
    episode: 2,
    category: 'dealer-tactics',
    tags: ['finance office', 'dealer tactics', 'F&I'],
    youtubeId: 'jBHxiHRJgYk',
  },
  {
    id: 'vlog-003',
    title: '5 Questions Nobody Thinks to Ask on a Test Drive',
    description:
      'Everyone asks how does it drive. Nobody asks the five things that actually predict whether you\'ll regret the purchase in six months. We walk through each one with a real car on a real Oregon back road.',
    thumbnail:
      'https://readdy.ai/api/search-image?query=couple%20on%20a%20scenic%20test%20drive%20Oregon%20coastal%20highway%20winding%20road%20through%20evergreen%20forest%20passenger%20looking%20at%20driver%20both%20engaged%20checking%20car%20controls%20sunlight%20through%20windshield%20warm%20afternoon%20light%20candid%20authentic%20photography%20wide%20angle&width=800&height=450&seq=vlog-ep3-thumb&orientation=landscape',
    duration: '14:55',
    publishedAt: '2025-10-28',
    publishDate: 'Oct 28, 2025',
    views: 6892,
    episode: 3,
    category: 'buying-tips',
    tags: ['test drive', 'car buying', 'what to check'],
    youtubeId: 'W0LHTWG-UmQ',
  },
  {
    id: 'vlog-004',
    title: 'Why We Film Every Single Car We Sell — And You Should Demand It',
    description:
      'We made a rule: if we won\'t film it, we won\'t sell it. Here\'s how that policy came about, what we\'ve caught on camera that saved buyers from bad deals, and why every other dealer should be doing the same.',
    thumbnail:
      'https://readdy.ai/api/search-image?query=professional%20videographer%20filming%20a%20used%20car%20in%20a%20well-lit%20automotive%20garage%20camera%20on%20tripod%20ring%20light%20setup%20white%20background%20clean%20minimalist%20automotive%20photography%20setup%20behind%20the%20scenes%20production%20Oregon%20dealership%20warm%20neutral%20tones&width=800&height=450&seq=vlog-ep4-thumb&orientation=landscape',
    duration: '11:38',
    publishedAt: '2025-11-19',
    publishDate: 'Nov 19, 2025',
    views: 5124,
    episode: 4,
    category: 'rockhound-life',
    tags: ['transparency', 'video walkthroughs', 'our process'],
    youtubeId: 'dQw4w9WgXcQ',
    tiktokClipUrl: 'https://www.tiktok.com/@rockhoundauto',
  },
  {
    id: 'vlog-005',
    title: 'Extended Warranties: The $3,000 Question Nobody Answers Honestly',
    description:
      'Third-party warranties, dealer add-ons, manufacturer CPO coverage — we break down what\'s worth it, what\'s theater, and the one scenario where a warranty actually pays for itself. Spoiler: it\'s not what they tell you.',
    thumbnail:
      'https://readdy.ai/api/search-image?query=extended%20warranty%20contract%20document%20on%20a%20desk%20with%20a%20magnifying%20glass%20highlighting%20fine%20print%20text%20close%20up%20detail%20shot%20dramatic%20side%20lighting%20editorial%20style%20automotive%20consumer%20rights%20documentation%20paperwork%20research%20investigative%20journalism%20aesthetic%20warm%20tones&width=800&height=450&seq=vlog-ep5-thumb&orientation=landscape',
    duration: '19:44',
    publishedAt: '2025-12-10',
    publishDate: 'Dec 10, 2025',
    views: 9763,
    episode: 5,
    category: 'industry-watch',
    tags: ['extended warranty', 'CPO', 'avoid getting burned'],
  },
];
